import {resource} from '@albert-io/json-api-framework/request/builder';

export default function getClassroomInvitationsQuery(studentEmail: string) {
  return resource('classroom_invitations_v1')
    .mandarkEndpoint(['classroom_invitations_v1'])
    .include('classroom_v1')
    .include('classroom_v1.subjects_v2') // subjects gate which invitations the access modal prioritizes
    .include('issuer_v1') // teacher who sent the invite, used in adaptive class access modal
    .filter({
      email: encodeURIComponent(studentEmail),
      accepted_at: {
        null: true
      },
      classroom_v1: {
        status: 'active'
      }
    });
}
